import React, { useState, useEffect, useMemo, useRef } from 'react';
// import { useHistory, useLocation } from 'react-router-dom';
// import i18n from 'i18next';
import { Grid2, Select, MenuItem, Button, useMediaQuery, Hidden, List, ListItem } from '@mui/material';
import { StaticDatePicker } from '@mui/x-date-pickers';
import FullCalendar from '@fullcalendar/react';
import timegrid from '@fullcalendar/timegrid';
import daygrid from '@fullcalendar/daygrid';
import interaction from '@fullcalendar/interaction';
import luxon from '@fullcalendar/luxon3';

import { useTranslation } from 'core/contexts/localization';

import getFullcalendarLocale from 'core/locales/getFullcalendarLocale';

import { TIME_ZONES } from 'core/libs/core-ui/utils/dateTimeFormatted';

import { useStyles } from './styles';
import { Lens } from '@mui/icons-material';

const CalendarPage = ({
    useCalendarPage,
    schedules,
    renderEventContent,
    setCalendarRange,
    value,
    onChange,
    start,
    end,
    range,
    ref,
    onSelect,
    onDismiss,
    tz,
    setTz,
    title,
    isSmall,
    showCreateEventeButton = true,
    onEventClick,
    children,
    showExperiencesList = false,
    ...props
}) => {
    // const history = useHistory();
    const { t: translate } = useTranslation();
    const classes = useStyles();
    const smDown = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const smUp = useMediaQuery(theme => theme.breakpoints.up('sm'));

    const [calendarEvents, setCalendarEvents] = useState([
        {
            title: 'No events available',
            start: new Date('1970-01-01T00:00:00'), // Use old date
            end: new Date('1970-01-01T01:00:00'),
        },
    ]);
    const [date, setDate] = useState(new Date());
    const calendarRef = useRef(null);

    useEffect(() => {
        setTz(Intl.DateTimeFormat().resolvedOptions().timeZone);
    }, []);

    useEffect(() => {
        const calendarApi = calendarRef.current?.getApi();
        calendarApi.removeAllEvents()
        calendarApi.addEventSource(calendarEvents);
    },[calendarEvents]);

    useEffect(() => {
        if (schedules.length) {
            setCalendarEvents([...schedules]);
        }else{
          setCalendarEvents([]);
        }
    }, [schedules]);

    
    const handleChangeOfDate = (date) => {
        const calendarApi = calendarRef.current?.getApi();
        calendarApi?.gotoDate(date);
    };

    useEffect(() => {
        if (isSmall) {
            calendarRef?.current?.getApi().changeView('timeGridFourDay');
        } else {
            calendarRef?.current?.getApi().changeView('timeGridWeek');
        }
    }, [isSmall]);

    const Calendar = useMemo(
        () => (
            <>
                <FullCalendar // TODO: Most of this should be able to be override
                    locale={getFullcalendarLocale()}
                    datesSet={(data) => {
                        setCalendarRange({ start: data.start, end: data.end });
                        if (
                            data.start.getTime() > date.getTime() ||
                            data.end.getTime() < date.getTime()
                        ) {
                            setDate(data.start);
                        }
                    }}
                    timeZone={tz || 'local'}
                    firstDay={1}
                    firstHour="10am"
                    minTime="10am"
                    ref={calendarRef}
                    plugins={[daygrid, timegrid, interaction, luxon]}
                    initialView={isSmall ? 'timeGridFourDay' : 'timeGridWeek'}
                    allDaySlot={false}
                    views={{
                        timeGridFourDay: {
                            type: 'timeGrid',
                            duration: { days: 3 },
                            buttonText: '3 ' + translate('fullcalendar.days'),
                        },
                    }}
                    slotDuration="00:30:00"
                    slotLabelInterval={30}
                    slotMinutes={30}
                    headerToolbar={{
                        right: 'prev,next',
                        center: isSmall
                            ? 'timeGridFourDay,timeGridDay'
                            : 'dayGridMonth,timeGridWeek,timeGridFourDay,timeGridDay',
                        start: '',
                        end: isSmall ? 'prev,next' : '',
                    }}
                    slotLabelFormat={{
                        hour: 'numeric',
                        hour12: false,
                        minute: '2-digit',
                        omitZeroMinute: false,
                        meridiem: false,
                    }}
                    eventTimeFormat={{
                        hour: 'numeric',
                        minute: '2-digit',
                        meridiem: 'short',
                        omitZeroMinute: true,
                    }}
                    // selectConstraint={{
                    //     start: format(new Date(), 'yyyy-MM-dd'),
                    // }}
                    events={calendarEvents}
                    eventContent={renderEventContent}
                    eventDisplay="block"
                    selectable={true}
                    select={onSelect} // This is when selecting slot in the calendar
                    eventClick={(event) => {
                        // This is when clicking an existing event in the calendar
                        onEventClick(event);
                    }}
                    // eventsSet={handleEvents}
                />
            </>
        ),
        [isSmall, calendarEvents, tz]
    );

    const datePickerRef = useRef();

    let allExps = []
    let expColorMap = []
    if (showExperiencesList) {
      allExps = schedules.map(sch => {return {
        name: sch.extendedProps.expName,
        expDetailId: sch.extendedProps.expDetailId,
      }}).filter((exp, index, arr) => arr.findIndex((ex) => ex.expDetailId === exp.expDetailId) === index);
      
      expColorMap = allExps.reduce((acc, expId, index) => {
        acc[expId.expDetailId] = props?.colorPalette[index % props?.colorPalette.length];
        return acc;
      }, {});
    }

    return (
        (<React.Fragment>
            <Grid2 container className={classes.calendarContainer}>
                  <Hidden mdDown>

                    <Grid2 size={{md: 3}} className={classes.datepicker} sx={{display: 'flex', flexDirection: 'column'}} justifyContent={'flex-start'} alignItems={'flex-start'}>
                        <div>
                            <h3 className={classes.datepickerTitle}>
                                {translate('profile.schedule')}
                            </h3>
                            {title && (
                              <h4 style={{ fontSize: '18px' }}>{title}</h4>
                            )}
                        </div>
                        <Grid2 size={{xs: 12}}>
                            { showCreateEventeButton ?
                            <Button
                                
                                style={{
                                    width: '90%',
                                    margin: '0.5rem 0',
                                    marginBottom: '15px',
                                    color: '#fff',
                                    backgroundColor: '#71ba6c',
                                }}
                                variant="contained"
                                onClick={onSelect}>
                                {/* TODO: Tranlsate this */}
                                CREAR
                            </Button> 
                            : <></>}
                        </Grid2>
                        <Select
                            style={{ width: '90%' }}
                            variant="outlined"
                            labelId="timezone"
                            id="timezone"
                            value={tz}
                            onChange={(e) => setTz(e?.target?.value)}
                            label="Time Zone">
                            {TIME_ZONES.map((tz) => (
                              <MenuItem
                                    style={{ color: 'black' }}
                                    value={tz.id}>
                                    {tz.name}
                                </MenuItem>
                            ))}
                        </Select>
                        <StaticDatePicker
                            inputRef={datePickerRef}
                            value={date}
                            sx={{marginTop: '10px', backgroundColor: 'transparent'}}
                            slotProps={{
                              actionBar: {
                                actions: []
                              },
                              toolbar: {
                                sx: {display: 'none'}
                              },
                              calendarHeader: {
                                disabled: true,
                              }
                            }}
                            onChange={(date) => {
                              setDate(date);
                              handleChangeOfDate(date);
                            }}
                            />
                        {showExperiencesList && allExps.length > 0 && (
                          <Grid2>
                            <h3 style={{fontSize: '20px', fontWeight: 'bold', margin: '2px 0px'}}>{props?.listTitle}</h3>
                            <List>
                              {allExps.map((exp) => {
                                return(
                                <ListItem style={{display: 'flex', alignItems: 'center', fontSize: '14px', padding: '8px 0px'}}>
                                  <Lens
                                    style={{
                                        borderRadius: '50%',
                                        fontSize: '12px',
                                        border: '2px solid white',
                                        color: expColorMap[exp.expDetailId]
                                    }}
                                  />
                                  <span>{exp.name}</span>
                                </ListItem>
                              )})}
                            </List>
                          </Grid2>
                        )}
                    </Grid2>
                            </Hidden>
                 <Hidden mdUp >

                    <Grid2
                    size={{xs: 12}}
                    container
                    alignItems="center"
                    justifyContent="center">
                        <Select
                            style={{ width: '90%', marginTop: '10px' }}
                            variant="outlined"
                            labelId="timezone"
                            id="timezone"
                            value={tz}
                            onChange={(e) => setTz(e?.target?.value)}
                            label="Time Zone">
                            {TIME_ZONES.map((tz) => (
                              <MenuItem
                              style={{ color: 'black' }}
                                    value={tz.id}>
                                    {tz.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid2>
                    <Grid2 size={{xs:12}}>
                        { showCreateEventeButton ?
                            <Button
                                style={{
                                    width: '100%',
                                    margin: '0.5rem 0',
                                    color: '#fff',
                                    backgroundColor: '#71ba6c',
                                  }}
                                variant="contained"
                                onClick={onSelect}>
                                {/* TODO: Tranlsate this */}
                                CREAR
                            </Button>
                        : <></>}
                    </Grid2>
                        </Hidden>
                <Grid2 sx={{flex: '1 1 auto'}}>
                    <div className={classes.calendar}>{Calendar}</div>
                </Grid2>
            </Grid2>
            {children}
        </React.Fragment>)
    );
};

CalendarPage.displayName = 'CalendarPage';

export default CalendarPage;
